import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '../i18n'

Vue.use(VueRouter)

export default new VueRouter({
    mode: "hash",
    routes: [
        {
            path: '/',
            redirect: `/${i18n.locale}/home`
        }, {
            path: '/:lang',
            component: {
                render(c: Vue.CreateElement) {
                    return c('router-view')
                }
            },
            children: [
                {
                    path: '',
                    component: () => import('@/views/Index.vue'),
                    children: [
                        {
                            path: '/',
                            component: () => import('@/views/Home.vue')
                        },
                        {
                            path: 'home',
                            name: 'Home',
                            component: () => import('@/views/Home.vue')
                        },
                        {
                            path: 'contact',
                            name: 'Contact',
                            component: () => import('@/views/Contact.vue')
                        },
                        {
                            path: 'statuut_bevoegdheden',
                            name: 'Statuut en bevoegdheden',
                            component: () => import('@/views/Statuut_Bevoegdheden.vue')
                        },
                        {
                            path: 'cv',
                            name: 'Curriculum Vitae',
                            component: () => import('@/views/Cv.vue')
                        },
                        {
                            path: 'medewerkers',
                            name: 'Medewerkers',
                            component: () => import('@/views/Medewerkers.vue')
                        },
                        {
                            path: 'jaarverslagen',
                            name: 'Jaarverslagen',
                            component: () => import('@/views/Jaarverslagen.vue')
                        },
                        {
                            path: 'klachten',
                            name: 'Klachten',
                            component: () => import('@/views/Klachten.vue')
                        },
                        {
                            path: "*",
                            component: () => import('@/views/Error.vue')
                        },
                    ]
                }
            ]
        },
        {
            path: "*",
            component: () => import('@/views/Error.vue')
        }]
})



